import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import coachRoutes from '@/router/coach'
import studentRoutes from '@/router/student';
import companyRoutes from "@/router/company";
import {Storage} from "@/utils/Storage";

Vue.use(VueRouter)

const routes = [
    ...coachRoutes,
    ...studentRoutes,
    ...companyRoutes,
    {
        path: '/',
        name: 'splash',
        component: () => import('@/views/entrance/Splash'),
        meta: {
            public: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/entrance/Login'),
        meta: {
            public: true,
            desktopToolbar: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/entrance/Register'),
        meta: {
            public: true,
            desktopToolbar: true,
        }
    },
    {
        path: '/confirm-mail',
        name: 'confirm-mail',
        component: () => import('@/views/entrance/ConfirmMail'),
        meta: {
            desktopToolbar: true,
        }
    },
    {
        path: '/select-profile',
        name: 'select-profile',
        component: () => import('@/views/entrance/SelectProfile'),
        meta: {
            desktopToolbar: true,
        }
    },
    {
        path: '/basic-info',
        name: 'basic-info',
        component: () => import('@/views/entrance/BasicInfo'),
        meta: {
            desktopToolbar: true,
        }
    },
    {
        path: '/coach/company-invitation',
        name: 'coach-company-invitation',
        component: () => import('@/views/entrance/CoachCompanyInvitation'),
        meta: {
            desktopToolbar: true,
        }
    },
    {
        path: '/admin/excel',
        name: 'admin.excel',
        component: () => import('@/views/admin/UploadExcel'),
        meta: {
            desktopToolbar: true,
        }
    },
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.meta && to.meta.public) {
        if (store.state.dialogActive) {
            store.state.dialogActive = false
            const fromRoutes = ['student.profile', 'coach.profile']
            if (fromRoutes.includes(from.name) && to.name === 'login') return next()
            if (to.name === 'register') return next()
            return next(false)
        }
        return next()
    } else {
        if (store.state.needConfirm) {
            store.state.showConfirm = true
            return next(false)
        }
        if (store.state.thirdDialogActive || store.state.secondDialogActive) {
            store.state.secondDialogActive = false
            store.state.thirdDialogActive = false
            return next(false)
        }
        if (store.state.dialogActive) {
            store.state.dialogActive = false
            const allowedRoutes = {
                'student.profile': ['student.profile.edit', 'student.payment.edit'],
                'coach.profile': ['coach.profile.edit', 'coach.payment.edit'],
                'coach.select-plan': ['coach.credit-card'],
                'company.profile': ['company.profile.edit', 'company.payment.edit'],
                'company.select-plan': ['company.credit-card'],
                'student.routines': ['student.routine.detail'],
                'basic-info': ['coach.home', 'student.home', 'company.home']
            }
            const allowed = allowedRoutes[from.name] && allowedRoutes[from.name].includes(to.name)
            return allowed ? next() : next(false)
        }

        await store.dispatch('getUserAccount')
        const user = await Storage.getUser()
        const account = await Storage.getAccount()
        let accountType = account && account.accountType || ''
        let accountName = account && account.name || ''
        let homeRoute = {name: `${accountType}.home`, replace: true}
        if (accountType === 'coach_company') homeRoute.name = 'coach.home'

        if (!user) return to.name === 'login' ? next() : next({name: 'login', replace: true})
        if (!user.emailVerified) return to.name === 'confirm-mail' ? next() : next({name: 'confirm-mail', replace: true})
        if (!accountType) return to.name === 'select-profile' ? next() : next({name: 'select-profile', replace: true})
        if (accountType === 'coach_company') {
            let routes = ['coach.payment.edit', 'coach.select-plan', 'coach.credit-card']
            if (routes.includes(to.name)) return next(false)
            if (account.firstLogin === true) return to.name === 'coach-company-invitation' ? next() : next({name: 'coach-company-invitation', replace: true})
        }
        if (!accountName) {
            if (accountType === 'coach_company') return next()
            return to.name === 'basic-info' ? next() : next({name: 'basic-info', replace: true})
        }

        if (accountType === 'coach' || accountType === 'company') {
            const hasStripeAccount = account && account.stripeAccount || null
            const hasPaymentMethod = hasStripeAccount && hasStripeAccount.paymentMethod && hasStripeAccount.paymentMethod.id || null
            const hasCurrentSubscription = hasStripeAccount && hasStripeAccount.currentSubscription && hasStripeAccount.currentSubscription.id || null
            const isFreeSubscription = hasStripeAccount && hasStripeAccount.currentSubscription && hasStripeAccount.currentSubscription.isFree === true
            if (!hasPaymentMethod && !isFreeSubscription) return to.name === `${accountType}.credit-card` ? next() : next({name: `${accountType}.credit-card`, replace: true})
            if (!hasCurrentSubscription) return to.name === `${accountType}.select-plan` ? next() : next({name: `${accountType}.select-plan`, replace: true})
            if (to.name === 'coach.statistics' && isFreeSubscription) return next(false)
        }

        if ((accountType && to.name === 'select-profile') || (accountName && to.name === 'basic-info')) return next(homeRoute)
        let noRestrictionRoutes = ['splash', 'login', 'register', 'confirm-mail', 'select-profile', 'basic-info', 'coach-company-invitation', 'admin.excel']
        if (accountType === 'coach_company') accountType = 'coach'
        if (!noRestrictionRoutes.includes(to.name) && !to.name.startsWith(accountType)) return next(false)

        return next()
    }
})

export default router
